import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { AideContextSection } from "../../models/aide-context.model";
import { PopoverModule } from "../../modules/popover/popover.module";
import { VlAideContentDirective } from "../../directives/aide-content.directive";

@Component({
  selector: "vl-aide-context",
  standalone: true,
  imports: [CommonModule, MatIcon, PopoverModule],
  templateUrl: "./aide-context.component.html",
  styleUrl: "./aide-context.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AideContextComponent {
  /** Libellé affiché à côté du "?" (ex: "Retour PDC") */
  label = input<string>();

  /** Sections du contenu d'aide (mode programmatique) */
  sections = input<AideContextSection[]>([]);

  /** Largeur max du popover en px */
  maxWidth = input<number>(320);

  /** Template projeté via <ng-template vlAideContent> */
  readonly contentTpl = contentChild(VlAideContentDirective);
}
